export default __webpack_public_path__ + "static/media/asofix_logo_new.f5c52e00.svg";